import { useAppDispatch, useAppSelector } from '../../../../lib/redux/hooks'
import { Calendar } from '../../../../ui/molecules/calendar'
import { ProtocolSearch } from '../../../../ui/molecules/ProtocolSearch'
import { MultiProtocolSearch } from '../../../../ui/molecules/ProtocolSearch/multisearch'
import { MadfarmStaticSelect } from '../../../../ui/molecules/select/newSelect/static'
import TextArea from '../../../../ui/molecules/textArea'
import { ReinforcedControlMeasureMotivationOptions } from '../../../../utils'
import { ReinforcedMotivationsEnum } from '../dataService/dto'
import { setReinforcedUpdateActiveFrom, setReinforcedUpdateClosingDate, setReinforcedUpdateClosingMotivationNote, setReinforcedUpdateClosingNote, setReinforcedUpdateClosingProtocolId, setReinforcedUpdateDepartureProtocolIds, setReinforcedUpdateEntryProtocolIds, setReinforcedUpdateMotivationNote, setReinforcedUpdateMotivationType, setReinforcedUpdateNote } from '../slice'
import '../styles.scss'

export function ReinforcedControlMeasureEditForm() {
    const dispatch = useAppDispatch()
    const reinforcedControlMeasureState = useAppSelector(state => state.reinforcedControlMeasure)

    return (
        <div className="flex flex-col gap-6 p-6">
            <div className="rounded-xl border border-neutral-200 bg-white shadow-sm overflow-hidden">
                <div className="bg-brandPrimary-600 px-6 py-4">
                    <span className="text-white font-semibold text-lg">Applicazione della Misura di Controllo Rinforzato</span>
                </div>
                <div className="p-6 flex flex-col gap-4">
                    <div className="grid grid-cols-2 gap-6">
                        <Calendar
                            label="Misura di Controllo Rinforzato attiva dal: "
                            errorLabel={reinforcedControlMeasureState.reinforcedControlMeasureErrors.activeFrom ? 'Data mancante' : undefined}
                            selected={reinforcedControlMeasureState.reinforcedControlMeasuresUpdateRequest.activeFrom}
                            onChange={(date) => dispatch(setReinforcedUpdateActiveFrom(date))}
                        />
                        <MadfarmStaticSelect
                            noOptionsMessage=''
                            label="Motivazione"
                            error={reinforcedControlMeasureState.reinforcedControlMeasureErrors.motivationType}
                            errorLabel='Motivazione mancante'
                            placeholder={'Seleziona motivazione...'}
                            value={reinforcedControlMeasureState.reinforcedControlMeasuresUpdateRequest.motivationType}
                            options={ReinforcedControlMeasureMotivationOptions}
                            onChange={(value) => {
                                //@ts-ignore
                                const newValue = value !== null ? value.value : null
                                dispatch(setReinforcedUpdateMotivationType(newValue))
                            }}
                        />
                    </div>
                    {
                        reinforcedControlMeasureState.reinforcedControlMeasuresUpdateRequest.motivationType === ReinforcedMotivationsEnum.ALTRO && (
                            <div className='grid grid-cols'>
                                <TextArea
                                    label="Descrizione della motivazione"
                                    value={reinforcedControlMeasureState.reinforcedControlMeasuresUpdateRequest.motivationNote}
                                    onChangeText={(text) => dispatch(setReinforcedUpdateMotivationNote(text))}
                                />
                            </div>
                        )
                    }

                    <div className='border-[0.5px] border-neutral-200' />
                    <span className="text-sm font-semibold uppercase tracking-widest text-brandPrimary-600">
                        Elenco Documenti che hanno generato l'applicazione della misura (Entrata)
                    </span>
                    <div className='grid grid-cols gap-6'>
                        <MultiProtocolSearch
                            type='entry'
                            defaultValue={reinforcedControlMeasureState.reinforcedControlMeasuresUpdateRequest.entryProtocolIds}
                            onSelect={(value) => dispatch(setReinforcedUpdateEntryProtocolIds(value))}
                        />
                    </div>
                    <span className="text-sm font-semibold uppercase tracking-widest text-brandPrimary-600">
                        Elenco Documenti che hanno generato l'applicazione della misura (Partenza)
                    </span>
                    <div className='grid grid-cols gap-6'>
                        <MultiProtocolSearch
                            type='departure'
                            defaultValue={reinforcedControlMeasureState.reinforcedControlMeasuresUpdateRequest.departureProtocolIds}
                            onSelect={(value) => dispatch(setReinforcedUpdateDepartureProtocolIds(value))}
                        />
                    </div>
                    <div className='border-[0.5px] border-neutral-200' />
                    <TextArea
                        label="Note"
                        value={reinforcedControlMeasureState.reinforcedControlMeasuresUpdateRequest.note}
                        onChangeText={(text) => dispatch(setReinforcedUpdateNote(text))}
                    />
                </div>
            </div>

            <div className="rounded-xl border border-neutral-200 bg-white shadow-sm overflow-hidden">
                <div className="bg-brandPrimary-600 px-6 py-4">
                    <span className="text-white font-semibold text-lg">Chiusura della Misura di Controllo Rinforzato</span>
                </div>

                <div className="p-6 flex flex-col gap-4">
                    <Calendar
                        label='Misura di Controllo Rinforzato chiusa il: '
                        selected={reinforcedControlMeasureState.reinforcedControlMeasuresUpdateRequest.closingDate}
                        onChange={(date) => dispatch(setReinforcedUpdateClosingDate(date))}
                        onClear={(date) => dispatch(setReinforcedUpdateClosingDate(date))}
                    />
                    <TextArea
                        label="Descrizione della motivazione di chiusura: "
                        value={reinforcedControlMeasureState.reinforcedControlMeasuresUpdateRequest.closingMotivationNote}
                        onChangeText={(text) => dispatch(setReinforcedUpdateClosingMotivationNote(text))}
                    />
                    <span className="text-sm font-semibold uppercase tracking-widest text-brandPrimary-600">
                        Comunicazione chiusura al Cliente
                    </span>
                    <ProtocolSearch
                        type='departure'
                        value={reinforcedControlMeasureState.reinforcedControlMeasuresUpdateRequest.closingProtocolId}
                        onSelect={(value) => dispatch(setReinforcedUpdateClosingProtocolId(value))}
                    />
                    <TextArea
                        label="Note"
                        value={reinforcedControlMeasureState.reinforcedControlMeasuresUpdateRequest.closingNote}
                        onChangeText={(text) => dispatch(setReinforcedUpdateClosingNote(text))}
                    />
                </div>
            </div>
        </div>
    )
}